export default __webpack_public_path__ + "assets/images/7382862c597fcac7f416a30b4d66d654.png";